import { fetchSubjects, FormDto, submitUmbracoForm } from "@/api"

export enum FormIds {
  CONTACT_US = "20921890f16e4ced9d633ee3747e1a3e",
}

export const fetchDataByFormId = async (formId: FormIds.CONTACT_US) => {
  switch (formId) {
    case FormIds.CONTACT_US:
      return await fetchSubjects()
  }
}

const DOMAIN_CODE_ID = "8abe3fd6-984d-46c2-c138-5f37b639dec7"

export type RelatedFields = Record<string, string> | undefined
export const defineRelatedSelectFields = (
  formId: FormIds.CONTACT_US,
): RelatedFields => {
  switch (formId) {
    case FormIds.CONTACT_US:
      return {
        subDomainCode: DOMAIN_CODE_ID,
      }
  }
}

export const setHiddenFieldValues = (
  formObject: any,
  fieldName: string,
  defaultValue: any,
) => {
  let foundInsuranceType = false
  for (const fieldset of formObject.pages[0].fieldsets) {
    if (foundInsuranceType) break
    for (const column of fieldset?.columns || []) {
      if (foundInsuranceType) break
      for (const field of column?.fields || []) {
        if (field?.alias === fieldName && field?.settings) {
          field.settings.defaultValue = defaultValue
          foundInsuranceType = true
          break
        }
      }
    }
  }
}

export const sendForm = async (
  convertedData: any,
  data: FormDto,
  locale: string,
) => {
  const response = await submitUmbracoForm(data.id, {
    culture: locale === "he" ? "he-il" : "en-us",
    values: convertedData.values,
  })
  return response
}
